// "ร้านค้าพันธมิตร" (partner shops) — shared by the homepage band (PartnerBand), the
// all-partners page (/partners) and the admin page (PartnerSettings). Mirrors the sponsor
// band's design: ONE Firestore doc holds the whole list, read through docCache.
//
// Doc shape (public/data/site_settings/partners):
//   { active: boolean,                       // master switch for the whole band
//     partners: [{ id, name, nameEn, url, imageUrl, active }],
//     updatedAt }
export const PARTNERS_DOC_PATH = 'public/data/site_settings/partners';
export const PARTNERS_COLLECTION = 'public/data/site_settings';
export const PARTNERS_DOC_ID = 'partners';
// docCache key = 'doc:' + path (utils/docCache getCachedDoc). The admin page clears it after
// every save so the editor's own browser sees the change at once; visitors within the TTL.
export const PARTNERS_CACHE_KEY = 'doc:' + PARTNERS_DOC_PATH;
export const PARTNERS_TTL = 30 * 60 * 1000;
export const MAX_PARTNERS = 24;               // hard cap — a runaway array must not flood the DOM
export const PARTNER_UPLOAD_FOLDER = 'site_assets/partners';   // Storage: public site-asset folder
export const PARTNER_MAX_FILE_SIZE = 3 * 1024 * 1024;

// Visible partners in admin order (hidden ones and the whole band when switched off drop out).
export function visiblePartners(data) {
    if (!data || data.active === false) return [];
    return (Array.isArray(data.partners) ? data.partners : [])
        .filter((p) => p && p.imageUrl && p.active !== false)
        .slice(0, MAX_PARTNERS);
}

// Outbound partner link with UTM tags so partners can attribute our traffic.
export function partnerHref(url, medium = 'home_partner') {
    if (!url) return null;
    try {
        const u = new URL(url);
        if (!u.searchParams.has('utm_source')) u.searchParams.set('utm_source', 'fastlanelv');
        if (!u.searchParams.has('utm_medium')) u.searchParams.set('utm_medium', medium);
        return u.toString();
    } catch (_) {
        return url;
    }
}
